import React, { useState } from 'react'
import { Form, Input, message, Button } from 'antd'
import Clipboard from 'clipboard'
import moment from 'moment'

const { Search } = Input
const App = () => {
  const formRef = React.useRef(null)
  const inputRef = React.useRef(null)
  const [result, setResult] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [showCodeArea, setShowCodeArea] = useState(false)
  const [messageApi, contextHolder] = message.useMessage()
  React.useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [])
  const onSearch = value => {
    // 加个延时，以解决allowClear绕过表单验证直接发请求的问题
    setTimeout(() => {
      // 手动触发表单验证
      formRef.current
        .validateFields()
        .then(success => {
          console.log(success)
          fetchData(value)
        })
        .catch(errorInfo => {
          // console.log(errorInfo)
        })
    }, 100)
  }
  const fetchData = str => {
    // 先清空原来的
    setResult('')
    setShowCodeArea(false)
    setIsLoading(true)
    // 使用moment.js转换时间
    setResult(moment(Number.parseInt(str)).format('YYYY-MM-DD HH:mm:ss'))
    // 显示代码区域
    setShowCodeArea(true)
    setIsLoading(false)
  }
  const copyToClipboard = text => {
    const res = Clipboard.copy(text)
    if (res) {
      messageApi.open({
        type: 'success',
        content: '已复制'
      })
    }
  }
  return (
    <>
      <Form
        ref={formRef}
        name="basic"
        labelCol={{
          span: 4
        }}
        wrapperCol={{
          span: 16
        }}
        autoComplete="off"
        initialValues={{
          str: moment().unix() * 1000
        }}
      >
        <Form.Item
          label="时间戳"
          name="str"
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: '请输入要转换的时间戳'
            },
            {
              pattern: new RegExp('^[1-9][0-9]{12}$'),
              message: '请输入正确的时间戳'
            }
          ]}
        >
          <Search
            ref={inputRef}
            onSearch={onSearch}
            enterButton
            loading={isLoading}
            allowClear
          />
        </Form.Item>
      </Form>
      {showCodeArea ? (
        <>
          <Button type="link" onClick={() => copyToClipboard(result)}>
            {result}
          </Button>
        </>
      ) : (
        ''
      )}
      {contextHolder}
    </>
  )
}
export default App
